<template>
<div class="chapter">
<div class="inner_page">
<div class="imagefp"><img alt="There Will Come a Time, by Carrie Arcos." class="imagefp" src="images/9781442495876_cover.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?a5f296ea